<template>
    <div class="row justify-content-center">
        <div class="col-12 col-md-11 col-lg-10">
            <div class="py-5 px-5 px-md-0">
                <div class="row align-items-center mb-5">
                    <div class="col-md-3 mb-4 mb-md-0" v-for="status in data.statuses">
                        <div class="card mb-4">
                            <div :class="`card-header bg-${status.class}`">
                                <span class="text-white">{{ status.translated_name }}</span>
                            </div>
                            <div class="card-body max-status-height custom-scrollbar">
                                <div class="mb-2">
                                    {{ $t('time') }}: {{ formatDateToLocal($optional(status, 'pivot', 'time')) }}
                                </div>
                                <div class="mb-2">&nbsp;</div>
                                <div class="text-muted">
                                    {{ $optional(status, 'pivot', 'note') }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 mb-4 mb-md-0" v-if="nextStatus(data.status)">
                        <div class="card mb-4">
                            <div :class="`card-header bg-${nextStatus(data.status).class}`">
                                <b>{{ $t('move_to') }}: </b> {{ nextStatus(data.status).translated_name }}
                            </div>
                            <div class="card-body max-status-height d-flex justify-content-center">
                                <button class="btn btn-lg" @click="openCloseStatusChangeModal">
                                    <i :class="`fa fa-chevron-right text-${nextStatus.class}`" style="font-size: 90px"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 mb-4 mb-md-0 mt-1" v-if="data.status.name === 'status_draft'">
                        <div class="card mb-4">
                            <div class="card-header bg-danger">
                                {{ $t('reject') }}
                            </div>
                            <div class="card-body max-status-height d-flex justify-content-center">
                                <button class="btn btn-lg" @click="openRejectModal">
                                    <i class="fa fa-times text-danger" style="font-size: 90px"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-order-status-change-modal
            v-if="isStatusModalActive"
            v-model="isStatusModalActive"
            :status="nextStatus(data.status)"
            :order_id="data.id"
        />

            <app-order-reject-order
                :order="data.id"
                v-if="isRejectModalActive"
                v-model="isRejectModalActive"
            />
<!--        <app-confirmation-modal-->
<!--                v-if="isRejectModalActive"-->
<!--                icon="trash-2"-->
<!--                modal-class="danger"-->
<!--                modal-id="app-confirmation-modal"-->
<!--                :message="$t('do_you_really_want_to_cancel_the_parcel', {-->
<!--                    status: $t('status_reject'),-->
<!--                    model: $t('order')-->
<!--                })"-->
<!--                @confirmed="rejectOrder"-->
<!--                @cancelled="isRejectModalActive = false"-->
<!--        />-->
    </div>
</template>

<script>
    import {numberWithCurrencySymbol, formatDateToLocal} from "../../../Helpers/Helpers";

    export default {
        name: "ExpandableOrderStatus",
        props: {
            data: {
                default: function () {
                    return {}
                }
            }
        },
        data() {
            return {
                isStatusModalActive: false,
                isRejectModalActive: false,
                numberWithCurrencySymbol,
                formatDateToLocal,
            }
        },
        methods: {
            openCloseStatusChangeModal() {
                this.isStatusModalActive = true;
            },
            openRejectModal() {
                this.isRejectModalActive = true;
            },
            rejectOrder() {

            }
        },
        computed: {
            nextStatus() {
                return (status) => {
                    if (status.name === 'status_draft') {
                        return {
                            name: 'status_confirmed',
                            class: 'info',
                            translated_name: this.$t('status_confirmed')
                        };
                    }
                    if (status.name === 'status_confirmed') {
                        return {
                            name: 'status_delivered',
                            class: 'success',
                            translated_name: this.$t('status_delivered')
                        };
                    }
                    return false;
                }
            }
        }
    }
</script>

<style scoped>
    .note-max-height {
        height: 100px;
        overflow: auto;
    }

    .bg-purple {
        background: #800080;
        color: #ffffff;
    }

    .text-purple {
        color: #800080;;
    }

    .max-status-height {
        height: 160px;
        overflow: auto;
    }
</style>